import React from "react";
import Login from "./pages/Login/Login";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoute from "./routes/PrivateRoute";
import Dashboard from "./pages/Dashboard/Dashboard";
import Employees from "./pages/Employees/Employees";
import Customers from "./pages/Customers/Customers";
import ProtectedLayout from "./components/layout/ProtectedLayout";
import { Toaster } from "react-hot-toast";
import Profile from "./pages/Profile/Profile";
import EmployeeDetails from "./pages/Employees/EmployeeDetails";
import Loans from "./pages/loans/Loans";
import Transactions from "./pages/Transactions/transactions";
import Vehicles from "./pages/Vehicles/Vehicles";
import CustomerDetails from "./pages/Customers/CustomerDetails";
import LoanDues from "./pages/loans/LoanDues";
import CreateLoan from "./pages/loans/CreateLoan";
import SinglePayment from "./pages/Payments/SinglePayment";
import Payments from "./pages/Payments/Payments";
import RoleRoute from "./routes/RoleRoute";
import Penalties from "./pages/Penalty/Penalties";
import NotificationsPage from "./pages/Notifications/Notifications";
import ReportPage from "./pages/Reports/Report";
import ForgotPassword from "./pages/Login/ForgotPassword";

function App() {
  return (
    <>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        containerStyle={{
          position: "fixed",
          zIndex: 999999,
        }}
        toastOptions={{
          style: {
            zIndex: 99999,
          },
        }}
      />
        <Router>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicRoutes />}>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route index element={<Navigate to="/login" replace />} />
          </Route>

          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<ProtectedLayout />}>
              <Route path="/customers/details" element={<CustomerDetails />} />
              <Route path="/loan-dues" element={<LoanDues />} />

              <Route path="/profile" element={<Profile />} />
              <Route path="notifications" element={<NotificationsPage />} />
              {/* <Route path="/payments/multiple" element={<MultiplePayment />} /> */}
              <Route element={<RoleRoute allowedRoles={["Admin"]} />}>
                <Route path="/employees" element={<Employees />} />
                <Route path="/penalties" element={<Penalties />} />
              </Route>
              <Route
                element={<RoleRoute allowedRoles={["Admin", "Employee"]} />}
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/employees" element={<Employees />} />
                <Route
                  path="/employees/details"
                  element={<EmployeeDetails />}
                />
                <Route path="/customers" element={<Customers />} />
                <Route path="/loans" element={<Loans />} />
                <Route path="/loan-create" element={<CreateLoan />} />
                <Route path="/payments/single" element={<SinglePayment />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/vehicles" element={<Vehicles />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/report" element={<ReportPage />} />
              </Route>
            </Route>
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
